"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Alert_1 = __importDefault(require("@material-ui/lab/Alert"));
var error_1 = require("../../utils/error");
exports.ErrorDisplay = function (_a) {
    var error = _a.error, props = __rest(_a, ["error"]);
    var message = error_1.parseError(error);
    return (react_1.default.createElement(Alert_1.default, __assign({ variant: "outlined" }, props, { severity: "error" }), message));
};
exports.WarningDisplay = function (_a) {
    var message = _a.message, props = __rest(_a, ["message"]);
    return (react_1.default.createElement(Alert_1.default, __assign({ variant: "outlined" }, props, { severity: "warning" }), message));
};
exports.InfoDisplay = function (_a) {
    var message = _a.message, props = __rest(_a, ["message"]);
    return (react_1.default.createElement(Alert_1.default, __assign({ variant: "outlined" }, props, { severity: "info" }), message));
};
exports.SuccessDisplay = function (_a) {
    var message = _a.message, props = __rest(_a, ["message"]);
    return (react_1.default.createElement(Alert_1.default, __assign({ variant: "outlined" }, props, { severity: "success" }), message));
};
//# sourceMappingURL=Display.js.map